/* JS ADA Fixes */

jQuery(document).ready(function() {
    jQuery('ul').removeAttr('aria-multiselectable');
	jQuery('nav > ul').removeAttr('aria-multiselectable');
	jQuery('[role=treeitem]').attr("aria-selected", "false");
	jQuery('#left-nav-links').removeAttr('aria-multiselectable');
	jQuery('#right-nav-links').removeAttr('aria-multiselectable');
	jQuery('.is-dropdown-submenu-parent').removeAttr('aria-expanded');
	jQuery('iframe').removeAttr('frameborder width height scrolling').attr('title', 'website iframe content');
	jQuery('.g-recaptcha-response').attr({'aria-hidden': 'true', 'aria-label': 'do not use', 'aria-readonly': 'true'});
	jQuery('#chatra__iframe').removeAttr('allow allowtransparancy sandbox');
	jQuery('#input_2_1').attr('title', 'email address');
	jQuery('.searchandfilter > div > ul > li > input').attr('title', 'search box');
	jQuery('.searchandfilter > div > ul > li > select').attr('title', 'category dropdown');
	jQuery('#lo_green_blinker').removeAttr('style');
	jQuery('kvs-lg-false').removeAttr('style');
	jQuery('.cart-icon a').attr('aria-label', 'cart icon');
	jQuery('u').replaceWith(function(){
		return jQuery('<span style="text-decoration:underline" />').append(jQuery(this).contents());
	});
	jQuery('b').replaceWith(function(){
		return jQuery('<strong />').append(jQuery(this).contents());
	});
});

jQuery(window).on("load", function() {
	const imgTitleEmptyAlt = jQuery('img[title][alt=""]');
	const imgTitleNoAlt = jQuery('img[title]:not([alt])');
	const imgNoAlt = document.querySelectorAll('img:not([title]):not([alt])');
	jQuery('iframe').removeAttr('frameborder width height scrolling').attr('title', 'website iframe content');
	jQuery('.g-recaptcha-response').attr({'aria-hidden': 'true', 'aria-label': 'do not use', 'aria-readonly': 'true'});
	// add empty alt text to images without titles set
	imgNoAlt.forEach(
		function(em){
			em.setAttribute( 'alt', '' );
		}
	);
	// add alt text to images that matches set titles - also finds empty titles, but will add/replace alt texts to empty, so it will still be compliant
	imgTitleEmptyAlt.each(
		function(){
			let title = jQuery(this).attr('title');
			jQuery(this).attr( 'alt', title )
		}
	);
	imgTitleNoAlt.each(
		function(){
			let title = jQuery(this).attr('title');
			jQuery(this).attr( 'alt', title )
		}
	);

	// fixes for Google Maps Easy
	jQuery('[title="Show street map with terrain"] > span').attr('title', 'Show street map with terrain');
	jQuery('[title="Show street map with terrain"] > span').removeAttr('role');
	jQuery('[title="Show imagery with street names"] > span').attr('title', 'Show imagery with street names');
	jQuery('[title="Show imagery with street names"] > span').removeAttr('role');
});